import { render, staticRenderFns } from "./ObjectDetail.vue?vue&type=template&id=0c48e439"
import script from "./ObjectDetail.vue?vue&type=script&lang=js"
export * from "./ObjectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports